import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { onINP, type INPMetricWithAttribution } from 'web-vitals/attribution';
import { getFaro } from '@/client/components/GrafanaFaro';
import { WebVitalsLabProps } from '../shared';
const sendBeacon = (pageName: string, data: INPMetricWithAttribution) => {
  const {
    id,
    value,
    delta,
    navigationType,
    rating
  } = data;
  const longestScriptStartTime = data.attribution.longestScript?.entry?.startTime ? Math.round(data.attribution.longestScript?.entry?.startTime) : '-';
  const values = {
    value,
    delta,
    inputDelay: data.attribution.inputDelay,
    processingDuration: data.attribution.processingDuration
  };
  const beacon = {
    id,
    pageName,
    navigationType,
    rating,
    attrInteractionTarget: data.attribution.interactionTarget,
    attrLongestScriptURL: data.attribution.longestScript?.entry?.sourceURL ?? '-',
    attrLongestScriptFunctionName: data.attribution.longestScript?.entry?.sourceFunctionName ?? '-',
    attrLongestScriptCharPosition: `${data.attribution.longestScript?.entry?.sourceCharPosition}`,
    longestScriptSubpart: data.attribution.longestScript?.subpart ?? '-',
    presentationDelay: `${data.attribution.presentationDelay}`,
    longestScriptStartTime: `${longestScriptStartTime}`
  };
  console.log(`%cINP-LAB track ${delta} ${value} ${JSON.stringify(beacon)}`, 'background: #222; color: #bada55');
  getFaro().api.pushMeasurement({
    type: 'INP-LAB',
    values
  }, {
    context: beacon
  });
};
const shouldSend = (data: INPMetricWithAttribution): boolean => {
  return data.delta >= 190;
};
const InpTracker = t0 => {
  const $ = _c(3);
  const {
    pageName
  } = t0;
  let t1;
  if ($[0] !== pageName) {
    t1 = () => {
      console.log("%cINP-LAB active", "background: #222; color: #bada55");
      onINP(data => {
        if (shouldSend(data)) {
          sendBeacon(pageName, data);
        }
      });
    };
    $[0] = pageName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
};
export { shouldSend, InpTracker };